<template>
	<AtomCard class="aspect-square relative">
		<div class="absolute size-full">
			<AtomImage
				v-bind="image"
				:width="image.width ?? 768"
				:height="image.height ?? 768"
				img-class="size-full object-cover rounded"
				fit="cover"
			/>
		</div>
		<div class="relative p-8 flex flex-col gap-4 justify-end h-full text-white bg-gradient-to-t from-black/90 to-transparent rounded">
			<AtomTitle
				tag="h3"
				size="lg"
			>
				{{ title }}
			</AtomTitle>
			<p class="text-paragraph-size-sm">
				{{ text }}
			</p>
			<div
				v-if="button"
				class="flex justify-end"
			>
				<AtomButton
					:variant="ButtonVariant.LightBorder"
					v-bind="button"
				/>
			</div>
		</div>
	</AtomCard>
</template>

<script lang="ts" setup>
import { ButtonVariant } from '#base/core/enums/ButtonVariantEnum';
import type { ImageType } from '#base/core/types/ImageType';
import type { UrlType } from '#base/core/types/UrlType';

const {
	title,
	text,
	image,
} = defineProps<{
	title: string;
	text: string;
	image: ImageType;
	button?: {
		to: UrlType;
		text: string;
	};
}>();
</script>
